module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "loginInfo"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.configuration.loginLogo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.configuration.projectName))]), _vm._v(" "), _c('div', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.pages_version))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCode),
      expression: "!isCode"
    }],
    staticClass: "logo_info"
  }, [_c('div', {
    staticClass: "inputStyle"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pics/log_right_icon_account.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.username),
      expression: "model.username",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "用户名",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "username", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputStyle"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pics/log_right_icon_password.png"),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.eyeImg) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.password),
      expression: "model.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "password", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.password),
      expression: "model.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "密码",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "password", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": [_vm.eyeImg ? _vm.visibleImg : _vm.unVisibleImg],
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.eyeImg = !_vm.eyeImg
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeZone"
  }, [_c('div', {
    staticClass: "inputStyle_new"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pics/log_right_icon_code.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.validateCode),
      expression: "model.validateCode",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.validateCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "validateCode", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "testCode"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc,
      "alt": ""
    },
    on: {
      "click": _vm.getVerifyCode
    }
  })])]), _vm._v(" "), _c('button', {
    ref: "loginBtn",
    staticClass: "submit_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('button', {
    ref: "loginBtnFace",
    staticClass: "submit_btn mt20",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.faceLogin
    }
  }, [_vm._v("人脸登录")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.tackPhoto) ? _c('camera', {
    attrs: {
      "tackPhoto": _vm.tackPhoto,
      "faceSet": _vm.faceSet
    },
    on: {
      "closeCamera": _vm.closeCamera
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.sendShow) ? _c('send', {
    attrs: {
      "openId": _vm.openId
    },
    on: {
      "hideSend": _vm.hideSend
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fdc7fa4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/login.vue
// module id = Dc3t
// module chunks = 6